import { takeEvery, put } from 'redux-saga/effects';
import { createAction } from 'redux-actions';
import { toastTypes } from 'constants/toastr';
import { actions } from 'components/common/toastr';

import {
  DOWNLOAD_FILE,
  DOWNLOAD_FILE_POST,
  UPLOAD_FILE,
  MY_AUCTIONS_ADD_JEWELRY,
  MY_AUCTIONS_UPDATE_LOT_STATUS,
  MY_AUCTIONS_UPDATE_LOT_REJECT_BID,
  MY_AUCTIONS_DELETE_BID,
  ACCOUNTS_ADD_BIDDER,
  ACCOUNTS_REMOVE_BIDDER,
  ACCOUNTS_SEND_EMAIL,
  MY_AUCTIONS_PLACE_BID,
  MY_AUCTIONS_UPDATE_LISTING,
  MY_AUCTIONS_UPDATE_AUCTION,
  MY_AUCTIONS_CREATE_NEW_AUCTION,
  ACCOUNTS_CHANGE_AUTH_TYPE,
  ACCOUNTS_CHANGE_PASSWORD,
  MY_AUCTIONS_REACTIVATE_LISTING,
  MY_AUCTIONS_LOT_CHANGE_DESCRIPTION,
  MANAGE_MEDIA_UPLOAD_LAB_REPORT,
  MANAGE_MEDIA_UPLOAD_APPRAISAL
} from 'constants/action-types';

const {
  actionTypes: { TOAST_MESSAGE }
} = actions;

function* throwErrorToast(action) {
  if (action.meta && action.meta.toastOptions) {
    yield put(
      createAction(TOAST_MESSAGE, () => {
        let errorMessage = `${action.meta.toastOptions.errorMessage}. ${action.payload}`;
        if (action.meta && action.meta.status && action.meta.status === 413) {
          errorMessage = `${action.meta.toastOptions.errorMessage}. File content too large`;
        }
        return {
          message: errorMessage,
          toastType: toastTypes.error
        };
      })()
    );
  }
}

function* throwSuccessToast(action) {
  if (action.meta && action.meta.toastOptions) {
    yield put(
      createAction(TOAST_MESSAGE, () => ({
        message: action.meta.toastOptions.successMessage,
        toastType: toastTypes.success
      }))()
    );
  }
}

export default function* toastSaga() {
  yield takeEvery(
    [
      DOWNLOAD_FILE_POST.success,
      DOWNLOAD_FILE.success,
      UPLOAD_FILE.success,
      MY_AUCTIONS_ADD_JEWELRY.success,
      MY_AUCTIONS_UPDATE_LOT_STATUS.success,
      MY_AUCTIONS_UPDATE_LOT_REJECT_BID.success,
      MY_AUCTIONS_DELETE_BID.success,
      ACCOUNTS_ADD_BIDDER.success,
      ACCOUNTS_REMOVE_BIDDER.success,
      MY_AUCTIONS_PLACE_BID.success,
      MY_AUCTIONS_UPDATE_LISTING.success,
      MY_AUCTIONS_UPDATE_AUCTION.success,
      MY_AUCTIONS_CREATE_NEW_AUCTION.success,
      ACCOUNTS_CHANGE_AUTH_TYPE.success,
      ACCOUNTS_CHANGE_PASSWORD.success,
      MY_AUCTIONS_LOT_CHANGE_DESCRIPTION.success,
      ACCOUNTS_SEND_EMAIL.success,
      MY_AUCTIONS_REACTIVATE_LISTING.success
    ],
    throwSuccessToast
  );
  yield takeEvery(
    [
      DOWNLOAD_FILE_POST.error,
      DOWNLOAD_FILE.error,
      UPLOAD_FILE.error,
      MY_AUCTIONS_ADD_JEWELRY.error,
      MY_AUCTIONS_UPDATE_LOT_STATUS.error,
      MY_AUCTIONS_UPDATE_LOT_REJECT_BID.error,
      MY_AUCTIONS_DELETE_BID.error,
      ACCOUNTS_ADD_BIDDER.error,
      ACCOUNTS_REMOVE_BIDDER.error,
      MY_AUCTIONS_PLACE_BID.error,
      MY_AUCTIONS_UPDATE_LISTING.error,
      MY_AUCTIONS_UPDATE_AUCTION.error,
      MY_AUCTIONS_CREATE_NEW_AUCTION.error,
      ACCOUNTS_CHANGE_AUTH_TYPE.error,
      ACCOUNTS_CHANGE_PASSWORD.error,
      MY_AUCTIONS_LOT_CHANGE_DESCRIPTION.error,
      ACCOUNTS_SEND_EMAIL.error,
      MY_AUCTIONS_REACTIVATE_LISTING.error,
      MANAGE_MEDIA_UPLOAD_LAB_REPORT.error,
      MANAGE_MEDIA_UPLOAD_APPRAISAL.error
    ],
    throwErrorToast
  );
}
